module.exports = new __parcel__URL__("MIMLogo.ea9454b3.svg").toString();